export const convertLocaleType = (locale: string) => {
  switch (locale) {
    case 'zh_tw':
      return 'zh-TW';
    case 'zh_hk':
      return 'zh-HK';
    case 'en':
      return 'en';
    case 'ja':
      return 'ja';
    case 'zh_cn':
      return 'zh-CN';
    default:
      return 'zh-HK';
  }
};
